import { addDays, isBefore, parseISO } from 'date-fns'

import { TaxReturn } from '../../../../../types/taxReturn'

/* We only display suggestions for the current VAT declaration */
export const getCurrentVatDeclarationId = (vatDeclarations?: TaxReturn[]): string | null => {
  if (!vatDeclarations || vatDeclarations.length === 0) {
    return null
  }

  const latestDeclaration = vatDeclarations[0]
  const previousDeclaration = vatDeclarations[1]

  /* If the latest declaration is settled, there're no suggestions to display */
  if (latestDeclaration?.isSettled) {
    return null
  }

  /* If the previous declaration is settled or doesn't exist (e.g. only one declaration exists), we can assume that the latest declaration is the current one to display suggestions for, as it is not settled (previous condition) */
  if ((previousDeclaration && previousDeclaration.isSettled) || !previousDeclaration) {
    return latestDeclaration.id
  }

  /* If two latest available declarations exist and are unsettled, we need to decide what to show, starting with the 2nd latest: */
  /* If the previous declaration has a reportDeadline, check if today is the deadline + 7 days (business assumption) */
  if (previousDeclaration?.reportDeadline) {
    const deadlineDate = parseISO(previousDeclaration.reportDeadline)
    const endDate = addDays(deadlineDate, 7)
    const today = new Date()

    /* If the 2nd latest declaration is still within the 7-day period after the deadline, show it */
    if (isBefore(today, endDate)) {
      return previousDeclaration.id
    } else {
      /* Otherwise, 2nd latest is overdue so show the latest declaration */
      return latestDeclaration.id
    }
  }

  /* If none of the above conditions are met, just show the latest declaration */
  return latestDeclaration.id
}
